.biel-suggested-questions {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 8px;
  font-size: 14px;
}

.biel-suggested-questions-title {
  color: var(--biel-text-color);
  margin-bottom: 10px;
}

.biel-suggested-questions-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.biel-suggested-question {
  background-color: var(--biel-suggested-questions-bg-color);
  border: 1px solid var(--biel-suggested-questions-border-color);
  border-radius: 8px;
  color: var(--biel-suggested-questions-text-color);
  cursor: pointer;
  padding: 8px 12px;
  font-family: var(--biel-font-family);
  transition: all 0.2s ease;
  width: fit-content;
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: left;
}

.biel-suggested-question:hover {
  background-color: var(--biel-suggested-questions-bg-hover-color);
  color: var(--biel-suggested-questions-text-hover-color);
}